import React from 'react'

import Box from 'components_new/atoms/Box'
import Chip from 'components_new/atoms/Chip'
import Text from 'components_new/atoms/Text'

import SelectSearch from 'components_new/molecules/SelectSearch'

import type { TAttributeOptionDto } from '@homepal/api-contract'
import { useTranslation } from 'language/translator'

interface SegmentMenuProps {
  segmentOptions: TAttributeOptionDto[]
  setCustomSegmentBy: (attributeOptionId: string) => void
}

const getSuggestedOptions = (options: TAttributeOptionDto[]) => {
  return [...options].filter((option) => option.suggested)
}

/**
 * Get all available and suggested options.
 * @param attributeOptionId - Current segment attribute option id.
 * @param segmentOptions - All available segmentation options for widget.
 */
const getOptions = (
  segmentOptions: TAttributeOptionDto[]
): [{ id: string; title: string }[], { id: string; title: string }[]] => {
  return [
    segmentOptions.map((item) => ({
      id: item.id,
      title: item.name
    })),
    getSuggestedOptions(segmentOptions).map((item) => ({
      id: item.id,
      title: item.name
    }))
  ]
}

const SegmentMenuSubContent = (props: SegmentMenuProps) => {
  const { segmentOptions, setCustomSegmentBy } = props
  const { t } = useTranslation()

  const [options, suggested] = getOptions(segmentOptions)

  return (
    <Box
      sx={{ width: 300, px: 2, py: 1 }}
      onClick={(ev) => ev.stopPropagation()}
    >
      <SelectSearch
        disableClearable={true}
        disabled={options.length === 0}
        multiple={false}
        onChange={(option) => setCustomSegmentBy(option.id)}
        options={options}
        selected={null}
        sx={{ mb: 2 }}
      />
      <Text
        color={'text.secondary'}
        component="div"
        variant="caption"
        sx={{ mb: 1 }}
      >
        {t('global', 'suggestion')}
      </Text>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 0.5
        }}
      >
        {suggested.map((option) => (
          <Chip
            clickable
            key={option.id}
            label={option.title}
            onClick={() => setCustomSegmentBy(option.id as string)}
            size="small"
          />
        ))}
      </Box>
    </Box>
  )
}

export default SegmentMenuSubContent
